/**
 * SGR Auto-Add v10.0 - Pure vanilla JS, fetch intercept
 * FIXES from v8.1:
 * - Uses theme's native cart-drawer.refresh() instead of innerHTML replacement
 * - MutationObserver to hide SGR controls in cart drawer dynamically
 * - Faster SGR removal sync (reduced delays)
 * - Better blocking of SGR quantity changes (covers line item keys too)
 */
(function() {
  if (window._sgrV10Loaded) return;
  window._sgrV10Loaded = true;

  var SGR_VARIANT_ID = 56802677915979;
  var SGR_VARIANT_STR = '56802677915979';
  var SGR_HANDLE = 'taxa-sgr';
  var SGR_TAG = 'taxa-sgr';
  var sgrBusy = false;
  var origFetch = window.fetch;
  var sgrCache = {};

  console.log('[SGR v10] Init');

  // ===== FETCH INTERCEPT =====
  window.fetch = function(input, init) {
    var url = typeof input === 'string' ? input : (input && input.url ? input.url : '');
    var method = (init && init.method) ? init.method.toUpperCase() : 'GET';

    // --- BLOCK: anyone trying to delete or change SGR quantity ---
    if (method === 'POST' && url.indexOf('/cart/change') !== -1 && !sgrBusy) {
      var bodyStr = '';
      if (init && init.body) {
        bodyStr = typeof init.body === 'string' ? init.body : '';
      }
      // Check if this change targets the SGR variant (by variant ID, handle, or line item key containing variant ID)
      if (bodyStr.indexOf(SGR_VARIANT_STR) !== -1 || bodyStr.indexOf(SGR_HANDLE) !== -1) {
        console.log('[SGR v10] BLOCKED: attempt to change SGR item');
        // Return current cart state so the UI stays consistent
        return origFetch('/cart.js', { credentials: 'same-origin' })
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            return new Response(JSON.stringify(cart), {
              status: 200,
              headers: { 'Content-Type': 'application/json' }
            });
          });
      }
    }

    // --- DETECT: POST to /cart/add ---
    if (method === 'POST' && url.indexOf('/cart/add') !== -1 && !sgrBusy) {
      console.log('[SGR v10] Detected cart/add');
      return origFetch.apply(this, arguments).then(function(response) {
        // Clone the response so we can read it AND the caller can too
        var cloned = response.clone();
        cloned.json().then(function(data) {
          try { handleCartAdd(data); } catch(e) { console.log('[SGR v10] handleCartAdd error:', e); }
        }).catch(function() {
          try { handleCartAdd(null); } catch(e) {}
        });
        return response;
      });
    }

    // --- DETECT: POST to /cart/change (non-SGR, passed the block above) ---
    if (method === 'POST' && url.indexOf('/cart/change') !== -1 && !sgrBusy) {
      console.log('[SGR v10] Detected cart/change');
      return origFetch.apply(this, arguments).then(function(response) {
        setTimeout(function() { syncSgrInCart(true); }, 300);
        return response;
      });
    }

    // --- DETECT: POST to /cart/update ---
    if (method === 'POST' && url.indexOf('/cart/update') !== -1 && !sgrBusy) {
      return origFetch.apply(this, arguments).then(function(response) {
        setTimeout(function() { syncSgrInCart(true); }, 300);
        return response;
      });
    }

    return origFetch.apply(this, arguments);
  };

  // ===== HANDLE ADD TO CART =====
  function handleCartAdd(responseData) {
    // Try to get the product handle from the response first
    var handle = null;
    if (responseData) {
      if (responseData.items && responseData.items.length > 0) {
        handle = responseData.items[0].handle;
      } else if (responseData.handle) {
        handle = responseData.handle;
      }
    }

    // Fallback: get handle from URL
    if (!handle) {
      var pathMatch = window.location.pathname.match(/^\/products\/([^\/\?#]+)/);
      if (pathMatch) {
        handle = pathMatch[1];
      }
    }

    if (!handle) {
      // Quick-add from collection page - just sync
      setTimeout(function() { syncSgrInCart(true); }, 500);
      return;
    }

    if (handle === SGR_HANDLE) return;

    checkProductSgr(handle, function(hasSgr) {
      if (hasSgr) {
        // Get quantity from response or from form input
        var qty = 1;
        if (responseData) {
          if (responseData.items && responseData.items.length > 0) {
            qty = responseData.items[0].quantity || 1;
          } else if (responseData.quantity) {
            qty = responseData.quantity;
          }
        }
        if (qty <= 0) qty = 1;

        console.log('[SGR v10] Adding SGR x' + qty);
        addSgrToCart(qty, function() {
          refreshCartUI();
        });
      }
    });
  }

  // ===== CHECK PRODUCT SGR TAG =====
  // Returns SGR multiplier per unit: 0 (no SGR), 1 (regular SGR product),
  // or N (bundle with N SGR-eligible bottles per bundle unit).
  // Detects:
  //   - tag "taxa-sgr"     → returns 1 (one SGR per item qty)
  //   - tag "taxa-sgr-N"   → returns N (N SGR per bundle qty, e.g. taxa-sgr-30)
  function checkProductSgr(handle, callback) {
    if (sgrCache[handle] !== undefined) { callback(sgrCache[handle]); return; }
    origFetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(prod) {
        var multiplier = 0;
        if (prod.tags) {
          var tags = typeof prod.tags === 'string' ? prod.tags.split(', ') : prod.tags;
          for (var i = 0; i < tags.length; i++) {
            var t = tags[i].toLowerCase().trim();
            if (t === SGR_TAG) {
              if (multiplier < 1) multiplier = 1;
            } else if (t.indexOf(SGR_TAG + '-') === 0) {
              // taxa-sgr-N pattern → bundle with N SGR per unit
              var n = parseInt(t.substring(SGR_TAG.length + 1), 10);
              if (!isNaN(n) && n > multiplier) multiplier = n;
            }
          }
        }
        sgrCache[handle] = multiplier;
        callback(multiplier);
      })
      .catch(function() { callback(0); });
  }

  // ===== ADD SGR TO CART =====
  function addSgrToCart(qty, onDone) {
    sgrBusy = true;
    origFetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: SGR_VARIANT_ID, quantity: qty }] })
    })
    .then(function(r) {
      sgrBusy = false;
      console.log('[SGR v10] SGR added:', r.status);
      // Small delay to let Shopify fully process the cart change before refreshing sections
      if (onDone) setTimeout(onDone, 600);
    })
    .catch(function() { sgrBusy = false; });
  }

  // ===== REFRESH CART UI (using theme's section rendering API) =====
  function refreshCartUI() {
    // Fetch the cart drawer sections and update specific selectors
    // This is what the theme's cart-items.refresh() does internally
    var cartItems = document.querySelector('cart-items');
    var sectionId = 'sections--29276878274891__cart-drawer';

    // Build sections URL for all relevant parts
    var sectionsToFetch = [sectionId, 'cart-icon-bubble', 'free-shipping-notice'];
    var sectionsParam = sectionsToFetch.join(',');

    console.log('[SGR v10] Refreshing cart UI via sections API');

    origFetch('/?sections=' + sectionsParam, { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(sections) {
        var parser = new DOMParser();

        // Update cart-items (the main cart drawer content)
        if (sections[sectionId]) {
          var doc = parser.parseFromString(sections[sectionId], 'text/html');

          // Update cart-items innerHTML
          var newCartItems = doc.querySelector('cart-items');
          if (newCartItems && cartItems) {
            cartItems.innerHTML = newCartItems.innerHTML;
            console.log('[SGR v10] Cart items updated');
          }

          // Update cart summary (totals)
          var newSummary = doc.querySelector('.cart-drawer__summary');
          var oldSummary = document.querySelector('.cart-drawer__summary');
          if (newSummary && oldSummary) {
            oldSummary.innerHTML = newSummary.innerHTML;
          }

          // Update promoted products
          var newPromo = doc.querySelector('#cart-promoted-products');
          var oldPromo = document.querySelector('#cart-promoted-products');
          if (newPromo && oldPromo) {
            oldPromo.innerHTML = newPromo.innerHTML;
          }
        }

        // Update cart icon bubble (count badge in header)
        if (sections['cart-icon-bubble']) {
          var bubbleDoc = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
          var newBubble = bubbleDoc.querySelector('.shopify-section');
          var oldBubble = document.getElementById('shopify-section-cart-icon-bubble');
          if (newBubble && oldBubble) {
            oldBubble.innerHTML = newBubble.innerHTML;
          }
        }

        // Update free shipping notice
        if (sections['free-shipping-notice']) {
          var freeDoc = parser.parseFromString(sections['free-shipping-notice'], 'text/html');
          var newFree = freeDoc.querySelector('.free-shipping-notice');
          var oldFree = document.querySelector('.free-shipping-notice');
          if (newFree && oldFree) {
            oldFree.innerHTML = newFree.innerHTML;
          }
        }

        // Re-lock SGR elements after DOM update
        setTimeout(lockSgrElements, 100);
      })
      .catch(function(e) {
        console.log('[SGR v10] Section refresh error:', e);
      });
  }

  function updateCartCountBadge(count) {
    var badges = document.querySelectorAll(
      '.cart-count, .js-cart-count, [data-cart-count], ' +
      '.header__cart-count, .cart-count-bubble span, ' +
      '#cart-icon-bubble .count-text'
    );
    badges.forEach(function(b) {
      b.textContent = count;
    });
    // Also try the cart icon bubble section
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble) {
      var countEl = bubble.querySelector('.count-text, .cart-count, span[aria-hidden]');
      if (countEl) countEl.textContent = count;
    }
  }

  // ===== SYNC SGR IN CART (core logic) =====
  function syncSgrInCart(forceRefresh) {
    if (sgrBusy) return;
    var syncKey = 'sgr_sync_ts';
    var lastSync = parseInt(sessionStorage.getItem(syncKey) || '0');
    if (!forceRefresh && Date.now() - lastSync < 2000) return;

    origFetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var currentSgrQty = 0;
        var sgrKey = null;
        var nonSgrItems = [];

        cart.items.forEach(function(item) {
          if (item.variant_id == SGR_VARIANT_ID) {
            currentSgrQty = item.quantity;
            sgrKey = item.key;
          } else {
            nonSgrItems.push(item);
          }
        });

        // If no other items but SGR exists, remove SGR immediately
        if (nonSgrItems.length === 0) {
          if (currentSgrQty > 0 && sgrKey) {
            console.log('[SGR v10] No products left, removing SGR');
            updateSgrQuantity(sgrKey, 0);
          }
          return;
        }

        // Check each product for SGR tag
        var completed = 0;
        var totalSgrNeeded = 0;

        nonSgrItems.forEach(function(item) {
          checkProductSgr(item.handle, function(sgrMultiplier) {
            // sgrMultiplier = 0 (no SGR), 1 (single product), N (bundle with N bottles/unit)
            if (sgrMultiplier > 0) totalSgrNeeded += item.quantity * sgrMultiplier;
            completed++;

            if (completed === nonSgrItems.length) {
              console.log('[SGR v10] Sync: need=' + totalSgrNeeded + ', have=' + currentSgrQty);

              if (totalSgrNeeded === currentSgrQty) return; // Already correct

              sessionStorage.setItem(syncKey, Date.now().toString());

              if (totalSgrNeeded === 0 && sgrKey) {
                // Remove SGR completely
                updateSgrQuantity(sgrKey, 0);
              } else if (currentSgrQty === 0 && totalSgrNeeded > 0) {
                // Add SGR
                addSgrToCart(totalSgrNeeded, function() {
                  if (window.location.pathname === '/cart') location.reload();
                  else refreshCartUI();
                });
              } else if (sgrKey) {
                // Update SGR quantity
                updateSgrQuantity(sgrKey, totalSgrNeeded);
              }
            }
          });
        });
      })
      .catch(function() {});
  }

  // ===== UPDATE SGR QUANTITY =====
  function updateSgrQuantity(key, qty) {
    sgrBusy = true;
    origFetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function() {
      sgrBusy = false;
      if (window.location.pathname === '/cart') {
        location.reload();
      } else {
        refreshCartUI();
      }
    })
    .catch(function() { sgrBusy = false; });
  }

  // ===== CSS: Hide SGR controls everywhere =====
  var css = document.createElement('style');
  css.id = 'sgr-hide-controls';
  css.textContent =
    /* Cart page - by class */
    '.cart-item--sgr .qty-input__btn,' +
    '.cart-item--sgr .qty-input__input,' +
    '.cart-item--sgr .cart-item__remove,' +
    '.cart-item--sgr .js-remove-item,' +
    '.cart-item--sgr quantity-input,' +
    '.cart-item--sgr [name="updates[]"],' +
    '.cart-item--sgr .increment-quantity,' +
    '.cart-item--sgr .decrement-quantity,' +
    '.cart-item--sgr .delete,' +
    '.cart-item--sgr .quantity-input,' +
    '.cart-item--sgr .input-button-group' +
    '{ display: none !important; pointer-events: none !important; visibility: hidden !important; }' +
    /* Cart drawer - by URL attribute */
    '[data-item-url*="taxa-sgr"] .qty-input,' +
    '[data-item-url*="taxa-sgr"] .cart-item__remove,' +
    '[data-item-url*="taxa-sgr"] .js-remove-item,' +
    '[data-item-url*="taxa-sgr"] quantity-input,' +
    '[data-item-url*="taxa-sgr"] button[name="minus"],' +
    '[data-item-url*="taxa-sgr"] button[name="plus"],' +
    '[data-item-url*="taxa-sgr"] .qty-input__btn,' +
    '[data-item-url*="taxa-sgr"] .qty-input__input,' +
    '[data-item-url*="taxa-sgr"] .cart-item__quantity,' +
    /* Cart drawer - by href in links */
    'a[href*="taxa-sgr"] ~ .qty-input,' +
    'a[href*="taxa-sgr"] ~ .cart-item__quantity,' +
    'a[href*="taxa-sgr"] ~ quantity-input,' +
    'a[href*="taxa-sgr"] ~ .js-remove-item,' +
    'a[href*="taxa-sgr"] ~ button,' +
    /* Generic: any container with SGR link - hide quantity and remove controls */
    '.sgr-locked quantity-input,' +
    '.sgr-locked .qty-input,' +
    '.sgr-locked .cart-item__remove,' +
    '.sgr-locked .js-remove-item,' +
    '.sgr-locked button[name="minus"],' +
    '.sgr-locked button[name="plus"],' +
    '.sgr-locked .qty-input__btn,' +
    '.sgr-locked .qty-input__input,' +
    '.sgr-locked .increment-quantity,' +
    '.sgr-locked .decrement-quantity,' +
    '.sgr-locked .delete,' +
    '.sgr-locked .input-button-group,' +
    '.sgr-locked .quantity-input' +
    '{ display: none !important; pointer-events: none !important; visibility: hidden !important; }';
  document.head.appendChild(css);

  // ===== MUTATION OBSERVER: dynamically hide SGR controls =====
  function lockSgrElements() {
    // Find all links to taxa-sgr and lock their parent cart item containers
    var sgrLinks = document.querySelectorAll('a[href*="taxa-sgr"]');
    sgrLinks.forEach(function(link) {
      // Find the closest cart item container (works for both cart page and drawer)
      var container = link.closest('tr, .cart-item, [class*="line-item"], li, [data-item-url]');
      if (container && !container.classList.contains('sgr-locked')) {
        container.classList.add('sgr-locked');
        container.classList.add('cart-item--sgr');

        // Also add informational label if not already present
        if (!container.querySelector('.sgr-auto-label')) {
          var label = document.createElement('div');
          label.className = 'sgr-auto-label';
          label.style.cssText = 'font-size:0.78em;color:#888;margin-top:4px;';
          label.textContent = 'Taxa SGR - cantitatea se ajusteaza automat';
          // Insert label near the product title link
          var titleParent = link.parentNode;
          if (titleParent) {
            titleParent.appendChild(label);
          }
        }
      }
    });

    // Also disable any quantity inputs and remove buttons by directly targeting them
    document.querySelectorAll('.sgr-locked input, .sgr-locked select').forEach(function(input) {
      input.setAttribute('readonly', 'readonly');
      input.setAttribute('disabled', 'disabled');
    });
  }

  // Run lockSgrElements on any DOM change (cart drawer open, re-render, etc.)
  var observer = new MutationObserver(function(mutations) {
    // Debounce - only run if there are actual added nodes
    var hasRelevantChange = false;
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length > 0) {
        hasRelevantChange = true;
        break;
      }
    }
    if (hasRelevantChange) {
      lockSgrElements();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Initial run
  lockSgrElements();

  // ===== CART PAGE: sync on load =====
  if (window.location.pathname === '/cart') {
    lockSgrElements();
    setTimeout(lockSgrElements, 500);
    setTimeout(lockSgrElements, 1500);
    setTimeout(function() { syncSgrInCart(false); }, 500);
  }

  console.log('[SGR v10] Ready');
})();
